module.exports = __webpack_public_path__ + "static/media/IMG_1411.8843ae84.JPG";